var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteralLoose(['\n'], ['\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component } from 'react';
import RangeSlider from './RangleSlider';
import styled from 'styled-components';
var Container = styled.div(_templateObject);

var Slider = function (_Component) {
  _inherits(Slider, _Component);

  function Slider(props, context) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.handleChange = function (value) {
      _this.setState({
        value: value
      });
    };

    _this.state = {
      value: _this.props.init ? _this.props.init : 0
    };
    return _this;
  }

  Slider.prototype.render = function render() {
    var value = this.state.value;
    var _props = this.props,
        min = _props.min,
        max = _props.max,
        showValue = _props.showValue;

    var numberWithCommas = function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    return React.createElement(Container, {
      className: 'slider'
    }, showValue && React.createElement('div', {
      className: 'value'
    }, React.createElement('h4', null, React.createElement('span', null, 'R', numberWithCommas(value)))), React.createElement(RangeSlider, _extends({
      min: min,
      max: max,
      value: value,
      onChangeStart: this.handleChangeStart,
      onChange: this.handleChange,
      onChangeComplete: this.handleChangeComplete
    }, this.props)));
  };

  return Slider;
}(Component);

export default Slider;